// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3neVI","consentsList":"PatientConsents_consentsList__3UHkh","consentsListEmpty":"PatientConsents_consentsListEmpty__3ueQX"};